export default "__VITE_ASSET__COaopH1Y__"